<template>
  <div class="button-google-auth">
    <b-button
      :disabled="!button_link"
      class="w-100 mb-3 button__google"
      variant="outline"
      @click="storeEntryPointAndRedirect"
    >
      <b-img :src="require('../../../assets/icon-google.svg')" />
      <span>Continue with Google</span>
    </b-button>
    <span class="divider"><span class="px-2">or</span> </span>
  </div>
</template>

<script>
import Utility from '@/models/Utility';

export default {
  data() {
    return {
      button_link: null
    };
  },

  async created() {
    this.fetchGoogleAuthURL();
  },

  methods: {
    async fetchGoogleAuthURL() {
      try {
        const {
          response: { data }
        } = await Utility.api().googleAuthURL();

        this.button_link = data.URL;
      } catch (error) {
        console.error(error);
      }
    },

    storeEntryPointAndRedirect() {
      const previousPath = this.$route.query.previousPath;
      
      // Store previousPath if it exists for post-OAuth redirect
      if (previousPath) {
        localStorage.setItem('previousPath', previousPath);
      } else {
        localStorage.removeItem('previousPath');
      }
      
      window.location.href = this.button_link;
    }
  }
};
</script>

<style lang="scss">
.button-google-auth {
  .button__google {
    display: flex;
    border: 1px solid #d1d2db;
    justify-content: center;
    padding: 12px 0;

    span {
      color: #3c4043;
      font-size: 14px;
      font-weight: 500;
      padding: 0 8px;
    }
  }

  .divider {
    font-size: 16px;
    font-weight: 700;
    color: #07091980;
    display: flex;
    align-items: center;
    height: auto;
    background: none;
    margin-bottom: 16px;
  }

  .divider::before,
  .divider::after {
    flex: 1;
    content: '';
    padding: 0.5px;
    background-color: #d1d2db;
  }

  .disabled {
    img {
      opacity: 0.5;
    }
    span {
      opacity: 0.5;
    }
  }
}
</style>
